import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Form, Input } from "antd";
import "antd/dist/antd.css";
import "../../css/users.css";
import { useNavigate } from "react-router-dom";
import LeftSideNav from "../../components/LeftSideNav";
import { isEmailValid } from "../../functions/commons";
import { isEmpty } from "lodash";
import { useForgotPasswordMutation } from "../../store/appSlice";
import { useAppDispatch } from "../../store/store";
import ReCAPTCHA from "react-google-recaptcha";

function ForgotPassword() {
  const layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 8 },
      lg: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 12 },
    },
  };

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [input, setInput] = useState({
    email: "",
  });

  const [error, setError] = useState({
    email: "",
  });

  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setLoading] = useState<boolean>(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [verified, setVerified] = useState<boolean>(false);

  const [forgotPassword] = useForgotPasswordMutation();

  useEffect(() => {
    if (!isEmpty(errorMessage)) {
      setTimeout(() => {
        setErrorMessage("");
      }, 2000);
    }
  }, [errorMessage]);

  const validation = () => {
    const { email } = input;

    setError({ ...error, email: "" });

    let valid = true;
    if (!isEmailValid(email)) {
      valid = false;
      setError({ ...error, email: "Email is invalid" });
    } else if (isEmpty(email)) {
      valid = false;
      setError({ ...error, email: "Email cannot be empty" });
    }

    return valid;
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInput({
      ...input,
      [event.target.id]: event.target.value,
    });
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    if (validation()) {
      setLoading(true);

      const payload = {
        email: input.email,
      };

      forgotPassword(payload)
        .unwrap()
        .then((incomingData: any) => {
          setLoading(false);

          navigate("/auth/verification_code");
        })
        .catch((err) => {
          setLoading(false);
          setErrorMessage(err?.data?.error?.message ?? "Something went wrong");
        });
    }

    console.log({ error });
  };

  const inputFormView = () => (
    <div className="main-right-div">
      <div className="signin-form-div">
        <h2>Forgot Password</h2>
        <p>Enter your email to receive otp code</p>

        {!isEmpty(errorMessage) && <Alert closable message={errorMessage} type="error" />}
        <Form {...layout} onFinish={handleSubmit}>
          <div className="sign-in__pswrd-frgt-pswrd">
            <h2>Email</h2>
          </div>
          <Form.Item name="email">
            <Input
              type="text"
              value={email}
              id="email"
              onChange={handleOnChange}
              style={!isEmpty(error.email) ? { borderColor: "red" } : {}}
            />
            {!isEmpty(error.email) && <text style={{ color: "red" }}>{error.email}</text>}
          </Form.Item>

          <ReCAPTCHA
            ref={recaptchaRef}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
            }}
            // sitekey="6Lf9bR8nAAAAABlnMXqFv1Y_rqPPLUTRpASCWXh_" //staging
            sitekey="6Ld4DhAnAAAAAL8GnDgf2efNiuV6KGkSCfl067v_"
            onChange={() => setVerified(true)}
          />
          <Form.Item>
            <div style={{ marginTop: 20 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                disabled={isLoading || !verified}
              >
                Submit
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );

  const { email } = input;
  return (
    <div className="login_container">
      <div className="left-nav-col">
        <LeftSideNav />
      </div>
      <div className="inputform_container">{inputFormView()}</div>
    </div>
  );
}

export default ForgotPassword;
